import { ContainerModule, interfaces } from 'inversify';
import { EditMarkingToolBlImpl, IEditMarkingToolBl } from './EditMarkingTool.bl';
import { EditMarkingToolStoreImpl, IEditMarkingToolStore } from './EditMarkingTool.store';
import { EditMarkingToolApiServiceImpl, IEditMarkingToolApiService } from './services/EditMarkingToolApi.service';
import { GetMarkingToolServiceImpl, IGetMarkingToolService } from './services/GetMarkingTool.service';

export const editMarkingToolModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IEditMarkingToolStore.$).to(EditMarkingToolStoreImpl).inSingletonScope();
  bind(IEditMarkingToolBl.$).to(EditMarkingToolBlImpl).inSingletonScope();
  bind(IEditMarkingToolApiService.$).to(EditMarkingToolApiServiceImpl).inSingletonScope();
  bind(IGetMarkingToolService.$).to(GetMarkingToolServiceImpl).inSingletonScope();
});
